import { useSuspenseQuery } from "@tanstack/react-query";
import sortBy from "lodash/sortBy";
import { useOnPropagate } from "@/frontend/@api/PropagateProvider";
import { client } from "@/frontend/@api/trpcClient";
import { useLoggedInUser } from "@/frontend/user/LoggedInUserProvider";

export function useUser(userId: string) {
    const key = "getUser";

    const { data: user } = useSuspenseQuery({
        queryKey: [key, userId],
        queryFn: () => client.user.getUser.query({ userId })
    });

    useOnPropagate(key, p => {
        p.onSingleDefaults("user", x => [key, x.id]);
    });

    return user;
}

export function useCurrentUser() {
    const { userId } = useLoggedInUser();
    return useUser(userId);
}

export const useUsers = () => {
    const key = "getAllUsers";

    const { data: rawUsers } = useSuspenseQuery({
        queryKey: [key],
        queryFn: () => client.user.getUsers.query()
    });

    const users = sortBy(rawUsers, x =>
        `${x.firstName} ${x.lastName}`.toLocaleLowerCase()
    );

    useOnPropagate(key, p => {
        p.onCollectionDefaults("user", [key]);
    });

    return users;
};

// re-export for prefetching (react-compiler eslint doesn't like passing hooks as reference)
export const reexported__useCurrentUser = useCurrentUser;
export const reexported__useUsers = useUsers;
